exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".filter {\n    margin-top: 5px;\n    width: 200px;\n    margin-right: 31px;\n    margin-bottom: 0px;\n}\n\n.text-center{\n    text-align: center\n}\n\n.odd{\n    background-color:#ffffff ;\n}\n.even{\n    background-color:#e6e6e6;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/report/report.component.css
// module id = ../../../../../src/app/report/report.component.css
// module chunks = main